import React, { useState } from 'react';
import '../../css/FAQs.css'; // Import the CSS file

const FAQNNATs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is the NNAT (Naglieri Nonverbal Ability Test)?",
      answer: "The NNAT is a nonverbal assessment used to measure a student's reasoning and problem-solving abilities, independent of language skills or prior knowledge."
    },
    {
      question: "Why Should My Child Take the NNAT?",
      answer: "The NNAT is widely used for gifted and talented program placements. It helps identify students with strong nonverbal reasoning skills who may excel in advanced learning programs."
    },
    {
      question: "How Can I Prepare for the NNAT?",
      answer: "Practice with NNAT-style questions, focusing on pattern recognition, spatial reasoning, and logical thinking. Exposure to practice tests can help familiarize students with the test format."
    },
    {
      question: "What Type of Questions Are on the NNAT?",
      answer: "The NNAT consists of nonverbal, visual-based questions including pattern completion, reasoning by analogy, serial reasoning, and spatial visualization."
    },
    {
      question: "What Age Group is the NNAT For?",
      answer: "The NNAT is commonly administered to students from kindergarten through grade 12, with question difficulty adjusted based on age level."
    }
  ];

  return (
    <div>
      <h1 className="nnat-title">
        Frequently Asked Questions
      </h1>
      <div className="faq-container">

        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => toggleQuestion(index)}
              style={{ cursor: 'pointer' }}
            >
              {faq.question}
              <span className={`faq-toggle-icon ${openIndex === index ? 'open' : ''}`}>
                {openIndex === index ? '-' : '+'}
              </span>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQNNATs;
